module.exports = __webpack_public_path__ + "img/skull_18_bj.6e0c60ed.png";